import React from 'react'

import LetterLanding from '../LetterLanding';

import logo_target from '../../../images/letterfunnel/linehub.webp';
import screenshot_target from '../../../images/letterfunnel/markodobroschelski.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLanding
      fullname="Marko Dobroschelski"
      firstname="Marko"
      companyname="Linehub"
      competition="TradeTracker en Awin"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/markodobroschelski.js